var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.06 1.18989C16.602 0.723038 17.2895 0.466797 18 0.466797C18.7105 0.466797 19.398 0.723038 19.94 1.18989L34.94 14.1199C35.2721 14.406 35.539 14.7621 35.7221 15.1636C35.9051 15.565 36 16.0021 36 16.4446V35.552C36 36.3604 35.6839 37.1357 35.1213 37.7074C34.5587 38.279 33.7957 38.6001 33 38.6001H21.5C21.1022 38.6001 20.7206 38.4396 20.4393 38.1538C20.158 37.8679 20 37.4803 20 37.0761V24.3757H16V37.0761C16 37.4803 15.842 37.8679 15.5607 38.1538C15.2794 38.4396 14.8978 38.6001 14.5 38.6001H3C2.20435 38.6001 1.44129 38.279 0.87868 37.7074C0.316071 37.1357 0 36.3604 0 35.552V16.4446C0 15.5505 0.388 14.699 1.06 14.1199L16.06 1.18989ZM18 3.51457L3 16.4446V35.552H13V22.8517C13 22.4475 13.158 22.0598 13.4393 21.774C13.7206 21.4882 14.1022 21.3276 14.5 21.3276H21.5C21.8978 21.3276 22.2794 21.4882 22.5607 21.774C22.842 22.0598 23 22.4475 23 22.8517V35.552H33V16.4446L18 3.51457Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.70f4917e8361f1e5213bb2f6da85ed4d.svg";
export { ForwardRef as ReactComponent };